import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ItemCategory_Create,
  ItemCategory_Update,
  ItemCategory_Delete,
  
  ItemCategory_ReadAll,
   ItemCategory_ReadById,
  ItemCategory_CreateBulk
} from 'src/app/GlobalVariable';

import {
  ItemCategoryCreateRequestDTO,
  ItemCategoryUpdateRequestDTO,
  ItemCategoryDeleteRequestDTO,
  ItemCategoryReadByIdRequestDTO,
  
  ItemCategoryDTO,
  ItemCategoryList,
  ItemCategoryCreateBulkRequestDTO,
} from './item-category.interface';

import { PaginatedDTO } from 'src/app/Common/common.interface';

@Injectable({
  providedIn: 'root',
})
export class ItemCategoryService {

  http = inject(HttpClient);


  ItemCategory_Create(
    data: ItemCategoryCreateRequestDTO
  ): Observable<ItemCategoryDTO> {
    return this.http.post<ItemCategoryDTO>(
      ItemCategory_Create,
      data
    );
  }

  ItemCategory_Update(
    data: ItemCategoryUpdateRequestDTO
  ): Observable<ItemCategoryDTO> {
    return this.http.post<ItemCategoryDTO>(
      ItemCategory_Update,
      data
    );
  }

  ItemCategory_Delete(
    data: ItemCategoryDeleteRequestDTO
  ): Observable<any> {
    return this.http.post<any>(
      ItemCategory_Delete,
      data
    );
  }

  ItemCategory_ReadAll(): Observable<ItemCategoryList> {
    return this.http.get<ItemCategoryList>(
      ItemCategory_ReadAll
    );
  }

  ItemCategory_ReadById(
    data: ItemCategoryReadByIdRequestDTO
  ): Observable<ItemCategoryDTO> {
    return this.http.post<ItemCategoryDTO>(
      ItemCategory_ReadById,
      data
    );
  }

  ItemCategory_CreateBulk(
    data: ItemCategoryCreateBulkRequestDTO
  ): Observable<any> {
    return this.http.post<any>(
      ItemCategory_CreateBulk,
      data
    );
  }

}